interface CompromissosAtrasadosOptions {
  gerencia?: number;
  responsaveis?: string[];
}

export default function (options?: CompromissosAtrasadosOptions) {
  const baseFilter = {
    status: {
      eq: 3,
    },
  };

  const ands: any[] = [baseFilter];

  if (options?.gerencia) {
    ands.push({
      responsavel: {
        perfisAcesso: {
          some: {
            perfil: {
              eq: options.gerencia,
            },
          },
        },
      },
    });
  }

  if (options?.responsaveis && options?.responsaveis.length > 0) {
    ands.push({
      responsavelCodigo: {
        in: options.responsaveis,
      },
    });
  }

  return {
    where: {
      and: ands,
    },
  };
}
